import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import filterObject from 'utils/filterObject';
export function formatPlaylistSubmissionData(_ref) {
  var _fields$externalRefId;
  var playlistForm = _ref.playlistForm,
    isEditMode = _ref.isEditMode;
  var fields = playlistForm.fields;
  var playlistData = {
    description: fields.description.changedValue,
    tags: fields.tags.changedValue,
    thumbnailId: fields.thumbnailId.changedValue,
    allow_member_contributions: fields.memberContributions.value,
    badge: fields.badge.changedValue,
    externalRefId: fields.externalRefId.wasChanged ? ((_fields$externalRefId = fields.externalRefId.value) === null || _fields$externalRefId === void 0 ? void 0 : _fields$externalRefId.trim()) || null : undefined,
    playlist_numbering: fields.displayContentNumbers.value
  };
  if (isEditMode) {
    playlistData = _objectSpread(_objectSpread({}, playlistData), {}, {
      topics: fields.topics.changedValue,
      allow_member_contributions: fields.memberContributions.changedValue,
      playlist_numbering: fields.displayContentNumbers.changedValue,
      name: fields.name.changedValue,
      locale: fields.locale.changedValue,
      owner: fields.owner.changedValue
    });
  } else {
    playlistData = _objectSpread(_objectSpread({}, playlistData), {}, {
      topics: fields.topics.value,
      name: fields.name.value,
      locale: fields.locale.value,
      owner: fields.owner.value
    });
  }

  // ensure we only send dirty payload
  var cleanedPlaylistData = filterObject(playlistData);
  return cleanedPlaylistData;
}